// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"491":"19f0ff0f","787":"0d1b732a"}[chunkId] + ".chunk.js";
};